import { parse, stringify } from 'query-string';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const sort_list = [
  { label: 'محبوب‌ترین', key: '-priority' },
  { label: 'گران‌ترین', key: '-payable_amount' },
  { label: 'ارزان‌ترن', key: 'payable_amount' }
];

const useSort = () => {
  const [sort_modal, set_sort_modal] = useState(false);
  const [active_sort, set_active_sort] = useState('-priority');

  const history = useHistory();
  const location = useLocation();

  // useEffect(() => {
  //   set_active_sort('-priority');
  // }, [history.location.pathname])

  useEffect(() => {
    const parsed_query = parse(location.search);
    if (
      !(!parsed_query.sort && active_sort === '-priority') ||
      !parsed_query.sort === active_sort
    ) {
      parsed_query.sort = active_sort;
      const new_url = `${location.pathname}?${stringify(parsed_query)}`;
      history.push(new_url);
    }
    // eslint-disable-next-line
  }, [active_sort]);

  return [sort_modal, set_sort_modal, active_sort, set_active_sort, sort_list];
};

export default useSort;
